var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible 1",
    clipPath: "url(#clip0_789_859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.89355 4.78298L8.89765 6.78707L8.90719 6.6821C8.90719 5.62914 8.05148 4.77344 6.99853 4.77344L6.89355 4.78298Z",
    fill: "#C7CBD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99819 3.50069C8.75415 3.50069 10.1793 4.92583 10.1793 6.6818C10.1793 7.09216 10.0966 7.48343 9.95344 7.84289L11.8144 9.70383C12.7751 8.90219 13.5322 7.86517 13.9998 6.6818C12.896 3.88881 10.1825 1.91016 6.99821 1.91016C6.1075 1.91016 5.25498 2.0692 4.46289 2.3555L5.83712 3.72654C6.19655 3.58658 6.58782 3.50069 6.99819 3.50069Z",
    fill: "#C7CBD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.636209 1.76723L2.08679 3.21781L2.37628 3.5073C1.32652 4.32803 0.496251 5.41915 0 6.68203C1.10067 9.47502 3.81731 11.4537 6.99842 11.4537C7.98457 11.4537 8.92616 11.2628 9.78825 10.9161L10.0587 11.1865L11.9132 13.0442L12.7244 12.2362L1.44739 0.956055L0.636209 1.76723ZM4.15452 5.28235L5.13748 6.26531C5.10885 6.40211 5.08976 6.53888 5.08976 6.68203C5.08976 7.73498 5.94547 8.59068 6.99842 8.59068C7.14157 8.59068 7.27837 8.5716 7.41197 8.54297L8.39493 9.52592C7.97183 9.73588 7.50105 9.86313 6.99842 9.86313C5.24245 9.86313 3.81731 8.43799 3.81731 6.68203C3.81731 6.17942 3.94457 5.70861 4.15452 5.28235Z",
    fill: "#C7CBD4"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_789_859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/invisible.7b81ac4a0564f57e0b5a1298a340f33b.svg";
export { ForwardRef as ReactComponent };